// extracted by mini-css-extract-plugin
module.exports = {"container":"Notification_container__j0_nd","fullHeight":"Notification_fullHeight___DT8w","iconContainer":"Notification_iconContainer__OPfX2","text":"Notification_text__BigJi"};